import { createRouter, createWebHashHistory } from 'vue-router'
import LandingPage from '../views/LandingPage.vue'
import DieselFuelCosts from '../views/DieselFuelCosts'
import DieselEquipmentCosts from '../views/DieselEquipmentCosts'
import DieselOtherCosts from '../views/DieselOtherCosts'
import ElectricFuelCosts from '../views/ElectricFuelCosts'
import ElectricEquipmentCosts from '../views/ElectricEquipmentCosts'
import ElectricOtherCosts from '../views/ElectricOtherCosts'

const routes = [
  // todo dynamic routes
  //DIESEL ROUTES
  {
    path: '/',
    name: 'LandingPage',
    component: LandingPage
  },
  {
    path: '/diesel/fuel-costs',
    name: 'DieselFuelCosts',
    component: DieselFuelCosts,
  },
  {
    path: '/diesel/equipment-costs',
    name: 'DieselEquipmentCosts',
    component: DieselEquipmentCosts
  },
  {
    path: '/diesel/other-costs',
    name: 'DieselOtherCosts',
    component: DieselOtherCosts
  },
  {
    path: '/diesel/:vehicle',
    redirect: {
      name: 'DieselFuelCosts'
    }
  },

  //ELECTRIC ROUTES
  {
    path: '/electric/fuel-costs',
    name: 'ElectricFuelCosts',
    component: ElectricFuelCosts
  },
  {
    path: '/electric/equipment-costs',
    name: 'ElectricEquipmentCosts',
    component: ElectricEquipmentCosts
  },
  {
    path: '/electric/other-costs',
    name: 'ElectricOtherCosts',
    component: ElectricOtherCosts
  },
  {
    path: '/electric/:vehicle',
    redirect: {
      name: 'ElectricFuelCosts'
    }
  },
  // { path: "/:pathMatch(.*)", redirect: LandingPage }
]

const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (window.location.href.indexOf('electric') > -1 || window.location.href.indexOf('diesel') > -1) {
      window.scrollTo(0, 390)
    }
  }
})

export default router
